import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import RefreshIcon from '@mui/icons-material/Refresh';
import HistoryList from './HistoryList';
const HistoryHeadings = () => {
  const [refresh, setRefresh] = useState(false);

  return (
    <div className="history-wrapper ">
      <Helmet>
        <title>History - DeTalks</title>
      </Helmet>
      <div className="flex-container text--md  outer-container">
        <div className="activity-div ">
          <p className="heading-color">Activity</p>
        </div>
        <div className="icon-div"></div>
        <div className="status-div">
          <p className="heading-color">Status</p>
        </div>

        <div className="actions-div flex-container justify-between">
          <p className="heading-color">Actions</p>
          <span onClick={() => setRefresh(!refresh)}>
            <RefreshIcon color="primary" style={{ cursor: 'pointer' }} />
          </span>
        </div>
      </div>
      <HistoryList key={refresh} />

      <style jsx>
        {`
          .history-wrapper {
            min-height: 90vh;
            padding: 20px;
          }
          .icon-div {
            width: 4%;
          }
          .activity-div {
            width: 25%;
            overflow: hidden;
          }
          .status-div {
            width: 35%;
          }

          .actions-div {
            width: 25%;
          }
          .heading-color {
            color: var(--gray-light);
          }
          .outer-container {
            border-bottom: 1px solid var(--border-gray);
            padding-bottom: 10px;
            justify-content: space-between;
          }
          .inner-div {
            color: var(--gray-darkest);
          }

          @media only screen and (max-width: 900px) {
            .activity-div {
              width: 40%;
            }
            .status-div {
              display: none;
            }

            .actions-div {
              width: 40%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default HistoryHeadings;
